import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Logo from './partials/Logo';
import FooterSocial from './partials/FooterSocial';

const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool
}

const defaultProps = {
  topOuterDivider: false,
  topDivider: false
}

class Footer extends React.Component {

  render() {
    const {
      className,
      topOuterDivider,
      topDivider,
      ...props
    } = this.props;

    const classes = classNames(
      'site-footer invert-color center-content-mobile',
      topOuterDivider && 'has-top-divider',
      className
    );

    return (
      <footer
        {...props}
        className={classes}
      >
        <div className="container">
          <div className={
            classNames(
              'site-footer-inner',
              topDivider && 'has-top-divider'
            )}>
            <div className="footer-top space-between text-xxs">
              <Logo />
              <FooterSocial />
            </div>
            <div className="footer-bottom space-between text-xxs invert-order-desktop">
              <div className="footer-copyright">版权所有&copy; 2021 - 至今 上海睿贝偲健康科技有限公司   </div>
            </div>
            <div className="footer-bottom space-between text-xxs invert-order-desktop">
              <nav class="footer-nav">
                <ul class="list-reset">
                  <li><a rel="noopener noreferrer" href='https://beian.miit.gov.cn/' target='_blank'>沪ICP备2021029570号</a></li>
                  <li><a rel="noopener noreferrer" href='http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502018446' target='_blank'>沪安网安备 31011502018446号</a></li>
                  <li><a rel="noopener noreferrer" href='http://www.12377.cn/' target='_blank'>不良信息举报中心</a></li>
                  <li><a rel="noopener noreferrer" target="_blank" href="https://xyt.xcc.cn/getpcInfo?sn=1582304182407213056&certType=8&url=*.robusthealth.cn&language=CN"><img src="https://program.xinchacha.com/xyt/xcc_small_ssl.png" alt="" style={{ width: '18px', highet: '18px' }} /></a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
